module.exports = __webpack_public_path__ + "img/banner.d0bd7201.png";